import api from "@/router/api";

export default {
  async baixarCertificado(atividadeId) {
    const response = await api.get("/certificado/meu/download", {
      params: { atividadeId },
      responseType: "blob",
    });
    return response.data;
  },

  async listarCertificadosUsuarioLogado() {
    const response = await api.get("/certificado/meus", {
      responseType: "blob",
    });
    return response.data;
  },

  async listarCertificadosMetadataUsuarioLogado() {
    const response = await api.get("/certificado/meus/metadata");
    return response.data;
  },

  async exportarAprovadosPlanilha(atividadeId) {
    const response = await api.get(
      `/certificado/atividade/${atividadeId}/aprovados/exportar`,
      {
        responseType: "blob",
      }
    );
    return response;
  },

  async exportarAprovadosCsv(atividadeId) {
    const response = await this.exportarAprovadosPlanilha(atividadeId);
    return response.data || response;
  },
};
